import en from './locale/en';
import es from './locale/es';
import pt_BR from './locale/pt_BR';

// Import flows translations
import enFlows from './locale/en/flows.json';
import esFlows from './locale/es/flows.json';
import ptBRFlows from './locale/pt_BR/flows.json';

export default {
  en: {
    ...en,
    ...enFlows,
  },
  es: {
    ...es,
    ...esFlows,
  },
  pt_BR: {
    ...pt_BR,
    ...ptBRFlows,
  },
};
